import axios from "axios";
import {TokenModule} from "../../modules/Token.module";

const instance = axios.create();

const setAxiosInstanceApiBaseUrl = (baseUrl: string) => {
    instance.defaults.baseURL = baseUrl;
}

const anonymousEndpoints = [
    "/api/settings"
]

// For each request add authentication bearer token
instance.interceptors.request.use(async function (config) {
    if (!config.headers) config.headers = {};
    if (!config.headers["Content-Type"]) config.headers["Content-Type"] = "application/json";
    if (!anonymousEndpoints.includes(config.url ?? "")) {
        const tokenResult = await TokenModule.getAccessToken();
        config.headers["Authorization"] = "Bearer " + tokenResult?.token;
    }
    return config;
}, function (error) {
    return Promise.reject(error);
});

export const AxiosConfig = {
    instance,
    setAxiosInstanceApiBaseUrl,
}